module.exports = __webpack_public_path__ + "assets/img/note-text1.222ced31.svg";